<div class="card">
  <div class="card-content">
    <div class="page-header">
      <h4 translationEditableDirective="INDUSTRIES">
        {{ 'INDUSTRIES' | translate }}
      </h4>
    </div>

    <div class="page-toolbar">
      <div class="buttons">
        <a
          [routerLink]="['create']"
          class="button is-small is-info"
          translationEditableDirective="CREATE_INDUSTRY"
          >{{ 'CREATE_INDUSTRY' | translate }}</a
        >
      </div>
      <form>
        <input
          class="input is-small"
          type="text"
          (input)="handleFilterChange($event)"
          [value]="getQueryParam('keyword')"
          name="keyword"
          [translationEditableModalDirective]="['SEARCH']"
          [placeholder]="'SEARCH' | translate"
        />
      </form>
    </div>

    <app-table
      [isLoading]="isLoading"
      [totalItems]="state.get('total')"
      [itemsPerPage]="getQueryParam('page_size')"
      [rows]="state.get('data')"
      [currentPage]="getQueryParam('page')"
      (onPageChange)="handlePageChange($event)"
      (onPageSizeChange)="handlePageSizeChange($event)"
      (onSort)="handleSort($event)"
      [sort]="getQueryParam('sort')"
      [orderBy]="getQueryParam('order_by')"
      [columns]="columns"
    >
      <ng-template let-row="row" #actionsColumn>
        <div class="buttons">
          <a
            [routerLink]="[row.get('id'), 'update']"
            class="button is-small"
            translationEditableDirective="UPDATE"
            >{{ 'UPDATE' | translate }}</a
          >
          <alert
            #deleteAlert
            (confirm)="deleteIndustry(row.get('id'))"
            titleTrnKey="ARE_YOU_SURE"
            textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS"
          />
          <button
            class="button is-danger is-small"
            (click)="deleteAlert.fire()"
            translationEditableDirective="DELETE"
          >
            {{ 'DELETE' | translate }}
          </button>
        </div>
      </ng-template>
    </app-table>
  </div>
</div>
